import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter } from 'react-router-dom';

// Global runtime guard for noisy third-party/injected promise errors.
if (typeof window !== 'undefined') {
  try {
    if (typeof globalThis.type === 'undefined') {
      globalThis.type = '';
    }
    if (typeof window.type === 'undefined') {
      window.type = '';
    }
  } catch (_) {}

  window.addEventListener('error', (event) => {
    const msg = String(event?.message || '');
    if (msg.toLowerCase().includes('type is not defined')) {
      console.error('[BBTV RuntimeGuard][error]', {
        message: event?.message,
        filename: event?.filename,
        lineno: event?.lineno,
        colno: event?.colno,
        stack: event?.error?.stack || null
      });
      event.preventDefault();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const message = String(reason?.message || reason || '');
    if (message.toLowerCase().includes('type is not defined')) {
      console.error('[BBTV RuntimeGuard][unhandledrejection]', {
        message,
        stack: reason?.stack || null
      });
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
